// extracted by mini-css-extract-plugin
export var button = "_as-4";
export var hasDarkBackground = "_as-7";
export var hasLightBackground = "_as-6";
export var iconWrapper = "_as-0";
export var large = "_as-2";
export var medium = "_as-1";
export var small = "_as-5";
export var xsmall = "_as-3";